"use client"

import { useState, useEffect } from "react"
import "./Popup.css"

const Popup = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [formData, setFormData] = useState({
    contactNo: "",
    requirements: "",
  })
  const [error, setError] = useState(null)

  // Check sessionStorage to show popup only once per session
  useEffect(() => {
    const hasSeenPopup = sessionStorage.getItem("hasSeenPopup")
    if (!hasSeenPopup) {
      const timer = setTimeout(() => {
        setIsOpen(true)
        sessionStorage.setItem("hasSeenPopup", "true")
      }, 2500) // 2.5 seconds delay (between 2-3 seconds)

      return () => clearTimeout(timer)
    }
  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError(null) // Reset error state

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/popup-submit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': process.env.REACT_APP_API_KEY, // Hardcoding for now; ideally use a proxy
        },
        body: JSON.stringify(formData),
      })

      const data = await response.json()
      if (response.ok) {
        console.log("Popup form submitted successfully:", data)
        setIsOpen(false) // Close popup on submission
        setFormData({
          contactNo: "",
          requirements: "",
        })
      } else {
        setError(data.error || "Failed to submit popup form")
      }
    } catch (err) {
      console.error("Error submitting popup form:", err)
      setError("An unexpected error occurred. Please try again.")
    }
  }

  const handleClose = () => {
    setIsOpen(false)
    setError(null) // Clear error on close
  }

  if (!isOpen) return null

  return (
    <div className="popup-overlay" onClick={handleClose}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <button className="popup-close" onClick={handleClose}>
          ×
        </button>
        <h3>Tell Us Your Requirements</h3>
        {error && <div className="error-message">{error}</div>}
        <form className="popup-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="contactNo">Contact Number *</label>
            <input
              type="tel"
              id="contactNo"
              name="contactNo"
              value={formData.contactNo}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="requirements">Requirements *</label>
            <textarea
              id="requirements"
              name="requirements"
              rows="3"
              value={formData.requirements}
              onChange={handleChange}
              required
            ></textarea>
          </div>
          <button type="submit" className="btn">Submit</button>
        </form>
      </div>
    </div>
  )
}

export default Popup